import React, { useState, useEffect } from "react";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import api from "../../api";

const SalaryStructurePage = () => {
    const [form, setForm] = useState({
        employee_id: "",
        salary_type: "MONTHLY",
        monthly_salary: "",
        daily_rate: "",
        hra: "",
        da: "",
        transport_allowance: "",
        medical_allowance: "",
        other_allowance: "",
        pf_deduction: "",
        esi_deduction: "",
        effective_from: "",
    });

    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchEmployees();
    }, []);

    const fetchEmployees = async () => {
        const res = await api.get("/teachers/list");
        setEmployees(res.data.data.map(e => ({ value: e.id, label: e.name })));
    };

    //   const setValue = (key, value) =>
    //     setForm(prev => ({ ...prev, [key]: value }));

    const setValue = (name, value, type = "text") => {
        let newValue = value;

        if (type === "text") {
            newValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

        } else if (type === "number") {
            newValue = value.replace(/[^0-9]/g, "");
        }

        setForm(prev => ({ ...prev, [name]: newValue }));
    };
    /* ---------- AUTO CALCULATION ---------- */

    const gross =
        form.salary_type === "MONTHLY"
            ? Number(form.monthly_salary || 0)
            : Number(form.daily_rate || 0);

    const allowances =
        Number(form.hra || 0) +
        Number(form.da || 0) +
        Number(form.transport_allowance || 0) +
        Number(form.medical_allowance || 0) +
        Number(form.other_allowance || 0);

    const deductions =
        Number(form.pf_deduction || 0) +
        Number(form.esi_deduction || 0);

    const netSalary = gross + allowances - deductions;

    /* ---------- SUBMIT ---------- */

    const handleSubmit = async () => {
        if (!form.employee_id || !form.effective_from)
            return toast.error("Employee & effective date required");

        setLoading(true);

        const payload = {
            employee_id: form.employee_id,
            salary_type: form.salary_type,
            monthly_salary:
                form.salary_type === "MONTHLY"
                    ? Number(form.monthly_salary || 0)
                    : null,
            daily_rate:
                form.salary_type === "DAILY"
                    ? Number(form.daily_rate || 0)
                    : null,
            hra: Number(form.hra || 0),
            da: Number(form.da || 0),
            transport_allowance: Number(form.transport_allowance || 0),
            medical_allowance: Number(form.medical_allowance || 0),
            other_allowance: Number(form.other_allowance || 0),
            pf_deduction: Number(form.pf_deduction || 0),
            esi_deduction: Number(form.esi_deduction || 0),
            effective_from: form.effective_from,
        };

        const res = await api.post("/salary-structure/add", payload);

        if (res.data.status) {
            toast.success("Salary structure saved");
            setForm({
                employee_id: "",
                salary_type: "MONTHLY",
                monthly_salary: "",
                daily_rate: "",
                hra: "",
                da: "",
                transport_allowance: "",
                medical_allowance: "",
                other_allowance: "",
                pf_deduction: "",
                esi_deduction: "",
                effective_from: "",
            });
        }

        setLoading(false);
    };

    return (
        <div style={page}>
            <ToastContainer />

            <div style={card}>
                <h2 style={title}>Create Salary Structure</h2>
                <p style={subtitle}>Enter salary & allowances</p>

                {/* Employee */}
                <Field label="Employee">
                    <Select
                        options={employees}
                        value={employees.find(e => e.value === form.employee_id)}
                        onChange={opt => setValue("employee_id", opt.value)}
                        //isClearable
                        styles={selectStyle}
                    />
                </Field>

                {/* Salary Type */}
                <div style={toggleWrapper}>
                    <button
                        style={form.salary_type === "MONTHLY" ? toggleActive : toggleBtn}
                        onClick={() => setValue("salary_type", "MONTHLY")}
                    >
                        Monthly
                    </button>
                    <button
                        style={form.salary_type === "DAILY" ? toggleActive : toggleBtn}
                        onClick={() => setValue("salary_type", "DAILY")}
                    >
                        Daily
                    </button>
                </div>

                {/* Salary */}
                <Row>
                    {form.salary_type === "MONTHLY" && (
                        <Field label="Monthly Salary">
                            <input style={input} type="text"
                                value={form.monthly_salary}
                                onChange={e => setValue("monthly_salary", e.target.value, "number")}
                            />
                        </Field>
                    )}

                    {form.salary_type === "DAILY" && (
                        <Field label="Daily Rate">
                            <input style={input} type="text"
                                value={form.daily_rate}
                                onChange={e => setValue("daily_rate", e.target.value, "number")}
                            />
                        </Field>
                    )}

                    <Field label="Effective From">
                        <input style={input} type="date"
                            value={form.effective_from}
                            onChange={e => setValue("effective_from", e.target.value, "date")}
                        />
                    </Field>
                </Row>

                {/* Allowances */}
                <Section title="Allowances">
                    <Row>
                        <Field label="HRA"><input style={input} type="text" value={form.hra} onChange={e => setValue("hra", e.target.value, "number")} /></Field>
                        <Field label="DA"><input style={input} type="text" value={form.da} onChange={e => setValue("da", e.target.value, "number")} /></Field>
                    </Row>
                    <Row>
                        <Field label="Transport"><input style={input} type="text" value={form.transport_allowance} onChange={e => setValue("transport_allowance", e.target.value, "number")} /></Field>
                        <Field label="Medical"><input style={input} type="text" value={form.medical_allowance} onChange={e => setValue("medical_allowance", e.target.value, "number")} /></Field>
                    </Row>
                    <Row>
                        <Field label="Other Allowance"><input style={input} type="text" value={form.other_allowance} onChange={e => setValue("other_allowance", e.target.value, "number")} /></Field>
                    </Row>
                </Section>

                {/* Deductions */}
                <Section title="Deductions">
                    <Row>
                        <Field label="PF Deduction"><input style={input} type="text" value={form.pf_deduction} onChange={e => setValue("pf_deduction", e.target.value, "number")} /></Field>
                        <Field label="ESI Deduction"><input style={input} type="text" value={form.esi_deduction} onChange={e => setValue("esi_deduction", e.target.value, "number")} /></Field>
                    </Row>
                </Section>

                {/* NET SALARY PREVIEW */}
                <Field label="Total Net Salary">
                    <input
                        style={{ ...input, background: "#f3f4f6", fontWeight: 600 }}
                        value={`₹ ${netSalary}`}
                        readOnly
                    />
                </Field>

                <button style={button} onClick={handleSubmit} disabled={loading}>
                    {loading ? <FaSpinner /> : "Save Structure"}
                </button>
            </div>
        </div>
    );
};

/* reusable components */

const Field = ({ label, children }) => (
    <div style={field}>
        <label style={labelStyle}>{label}</label>
        {children}
    </div>
);

const Row = ({ children }) => (
    <div style={row}>{children}</div>
);

const Section = ({ title, children }) => (
    <>
        <div style={sectionTitle}>{title}</div>
        {children}
    </>
);

/* styles */

const page = { background: "#eef2f7", minHeight: "100vh", padding: 30 };

const card = {
    maxWidth: 820,
    margin: "auto",
    background: "#fff",
    padding: 28,
    borderRadius: 16,
    boxShadow: "0 10px 35px rgba(0,0,0,0.08)"
};

const title = { textAlign: "center" };
const subtitle = { textAlign: "center", color: "#6b7280", marginBottom: 20 };

const row = { display: "flex", gap: 14, flexWrap: "wrap" };
const field = { flex: "1 1 48%", minWidth: 220, marginBottom: 14 };

const labelStyle = { fontSize: 13, fontWeight: 600, marginBottom: 6, display: "block" };
const input = {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "15px",
    boxSizing: "border-box",
};

const sectionTitle = { fontWeight: 600, marginTop: 10, marginBottom: 6 };

const toggleWrapper = { display: "flex", gap: 10, marginBottom: 10 };
const toggleBtn = { flex: 1, padding: 10, borderRadius: 8, border: "1px solid #ccc", background: "#fff", cursor: "pointer" };
const toggleActive = { ...toggleBtn, background: "#2563eb", color: "#fff", border: "none" };

const button = { marginTop: 12, width: "100%", background: "linear-gradient(90deg,#2563eb,#1d4ed8)", color: "#fff", border: "none", padding: 14, borderRadius: 10, fontWeight: 600, cursor: "pointer" };

const selectStyle = { control: (base) => ({ ...base, minHeight: 42, borderRadius: 8 }) };

export default SalaryStructurePage;